var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudio(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.92 28.16v2.56c0 .704-.576 1.28-1.28 1.28s-1.28-.576-1.28-1.28v-2.56A10.229 10.229 0 015.12 17.92h2.56c0 4.96 4 7.68 8.96 7.68s8.96-2.72 8.96-7.68h2.56c0 5.664-4.576 10.24-10.24 10.24zm-1.28-5.12c-2.816 0-5.12-2.304-5.12-5.12V6.4c0-2.816 2.304-5.12 5.12-5.12s5.12 2.304 5.12 5.12v11.52c0 2.816-2.304 5.12-5.12 5.12zM19.2 6.4c0-1.408-1.152-2.56-2.56-2.56s-2.56 1.152-2.56 2.56v11.52c0 1.408 1.152 2.56 2.56 2.56s2.56-1.152 2.56-2.56V6.4z"
  })));
}

export default SvgAudio;